<template>
  <div class="icon-container" :class="icon.iconPosition" ref="icon">
    <template v-if="icon.activeIconSrc && isActive">
      <cxIcon class="icon" v-if="icon.activeIconType === 'icon'"
        :options="iconOptions"
        :iconStyle="iconStyle"></cxIcon>
      <img class="icon" v-else-if="icon.activeIconType === 'img' && icon.activeIconSrc"
          :src="icon.activeIconSrc"
          :style="iconStyle"/>
    </template>
    <template v-else-if="icon.hoverIconSrc && isHover">
      <cxIcon class="icon" v-if="icon.hoverIconType === 'icon'"
        :options="iconOptions"
        :style="iconStyle"></cxIcon>
      <img class="icon" v-else-if="icon.hoverIconType === 'img' && icon.hoverIconSrc"
          :src="icon.hoverIconSrc"
          :style="iconStyle"/>
    </template>
    <template v-else>
      <cxIcon class="icon" v-if="icon.iconType === 'icon' && icon.showIcon !== false"
        :options="iconOptions"
        :iconStyle="iconStyle"></cxIcon>
      <img class="icon" v-else-if="icon.iconType === 'img' && icon.iconSrc && icon.showIcon !== false"
          :src="icon.iconSrc"
          :style="iconStyle"/>
    </template>
  </div>
</template>
<script>
import { remCheck } from 'utils';
export default {
  props: {
    icon: {
      type: Object,
      default: () => {}
    },
    direction: {
      type: String,
      default: 'normal'
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isHover: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    iconOptions() {
      let iconSrc = this.isActive ? this.icon.activeIconSrc : this.isHover ? this.icon.hoverIconSrc : this.icon.iconSrc
      return {
        iconSrc: iconSrc,
      }
    },
    iconStyle() {
      const data = this.icon || {}
      return {
        "display": "inline-block",
        "vertical-align": "middle",
        '--color': "rgba(0,0,0,1)",
        fontSize: "var(--iconSize)",
        width: "var(--iconSize)",
        height: "var(--iconSize)",
        margin: data.iconPosition === "left" ? `0 var(--iconMargin) 0 0` : 
                data.iconPosition === "right" ? `0 0 0 var(--iconMargin)` : 
                data.iconPosition === "top" ? `0 0 var(--iconMargin) 0` : 
                `var(--iconMargin) 0 0 0`
      }
    },
  },
  data() {
    return {
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.icon-container {
  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>